<template>
  <div class="wrap reserve-wrap">
    <Loading :visible="isLoadingPop"></Loading>
    <div class="top-header">
      <incBack></incBack>
      <h3>코칭 목표 작성하기</h3>
    </div>
    <div class="body-wrap">
      <VueSlickCarousel
        @afterChange="onAfterChange"
        :swipe="false"
        :arrows="false"
        :dots="false"
        ref="carousel"
        :infinite="false"
      >
        <div>
          <h4>
            이번 코칭에서 달성하고 싶은<br />
            목표를 작성해주세요.
          </h4>
          <!-- 코칭 목표 작성 -->
          <div class="goal-wrap pl-05 pr-05">
            <!-- 작성할 때 class="active" -->
            <textarea
              name=""
              id=""
              placeholder="Ex. 팀원들에게 좋은 피드백을 줄 수 있는 리더가 되기 위해 연구한다. "
              v-model="input.courseCoarchingSubject"
              @keyup="keyupEvent"
            ></textarea>
          </div>
        </div>
        <div>
          <h4>코치님에게 바라는 점이나 기타 의견을 작성해 주세요.</h4>
          <!-- 코칭 목표 작성 -->
          <div class="goal-wrap pl-05 pr-05">
            <!-- 작성할 때 class="active" -->
            <textarea
              name=""
              id=""
              v-model="input.courseCoarchingEtc"
            ></textarea>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
    <div class="bnb-btn">
      <!-- 선택 시 class="active" 활성화 -->
      <button
        @click="next()"
        :class="{ active: isActive }"
        v-if="current_slide == 0"
      >
        NEXT
      </button>
      <button @click="save()" :class="{ active: isActive }" v-else>
        저장하기
      </button>
      <!-- <p class="txt-blue">
                혹시 주제가 맘에 안든다면? <br>
                서베이를 한번 더 해볼 수 있어요!
            </p> -->
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import VueSlickCarousel from "vue-slick-carousel";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "coaching_goal_modify",
  props: {
    sessionIdx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    current_slide: 0,
    isActive: true,
    input: {
      coarchingIdx: 0,
      courseCoarchingSubject: "",
      courseCoarchingEtc: "",
    },
    isLoadingPop: false,
  }),
  components: {
    incBack,
    VueSlickCarousel,
    Loading,
  },
  mounted() {
    console.log(this.sessionIdx);
    this.getGoal();
  },
  methods: {
    save() {
      // console.log(this.input);
      this.isLoadingPop = true;
      let form = new FormData();
      for (const [key, value] of Object.entries(this.input)) {
        form.append(key, value);
      }
      this.axios
        .post(
          `/front/coarching/reserved/edit/purpose?sessionIdx=${this.sessionIdx}`,
          form
        )
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.isLoadingPop = false;
            this.$router.replace({
              name: "reservation_coaching_view",
              params: { sessionIdx: Number(this.sessionIdx) },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGoal() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reserved/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.input.coarchingIdx =
              res.data.contentinfo.reservedCoachingDetailDto.coarchingIdx;
            this.input.courseCoarchingSubject =
              res.data.contentinfo.reservedCoachingDetailDto.coarchingSubject;
            this.input.courseCoarchingEtc =
              res.data.contentinfo.reservedCoachingDetailDto.coarchingEtc;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    keyupEvent() {
      if (this.input.courseCoarchingContent1 != "") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    next() {
      if (this.isActive) {
        if (this.current_slide == 1) {
          this.$router.push("reserve_finish");
        } else {
          this.$refs.carousel.next();
        }
      }
    },
    onAfterChange(slideIndex) {
      this.current_slide = slideIndex;
      if (this.current_slide == 2) {
        this.isActive = false;
      }
    },
  },
};
</script>
